import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { CookiePolicyComponent } from '../cookie-policy/cookie-policy.component';

@Component({
  selector: 'app-cookie',
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.scss'],
})
export class CookieComponent implements OnInit {

  constructor(private _bottomSheetRef: MatBottomSheetRef<CookieComponent>, public dialog: MatDialog, private cookieService: CookieService) { }

  ngOnInit(): void {
  }
  
  acceptCookies() {
    const dialogRef = this.dialog.open(CookiePolicyComponent, { width:'800px',disableClose: true});
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Agreed') {
        let date: Date = new Date();
        this.cookieService.set("OptanonAlertBoxClosed", date.toUTCString(),365,"/",null,true);
        this._bottomSheetRef.dismiss();
      }
    });
  }
  
}
